export const Urls = {
    concat: (arr) => arr.join(),
    create: "/create",
    test: "/test",
    grade: "/grade",
    pre: "/pre",
    short: "/short",
    trans: "/trans",
    prompt: "/prompt",
    auto: "/auto",
    wild: "/*",
    process: (url)=> url+Urls.wild,
    myPage: "/myPage",
    testApp: "/testApp",
    testResult: "/testResult",
    notice: "/notice",
    qualification: "/qualification",
    transactions: "/transactions",
    feedback: "/feedback",
    res: '/res',
    req: '/req',
    profile: "/profile",
    alert: "/alert",
    ask: "/ask",
    logout: "/logout",
    cancel: "/cancel",
    apply: "/apply",

}

